import axios from "axios";

const getBase64 = (file: File) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

/**
 * Download an attachment shown in an antd <Upload> list.
 *
 * Stored files are served by GET /api/files/:id, which requires the bearer
 * token, so they cannot be opened as a plain link. Fetch them through axios
 * (which attaches the token) and hand the blob to the browser. Files that were
 * just picked in the form (not yet uploaded) carry a data: URL and open directly.
 */
const downloadAttachment = async (file: any) => {
  if (!file?.download) {
    if (file?.url) window.open(file.url, "_blank");
    return;
  }

  const blob = await axios
    .get(file.download, { responseType: "blob" })
    .then((res) => res.data);

  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = file.name || "attachment";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(objectUrl);
};

const helpers = {
  getBase64,
  downloadAttachment,
};

export default helpers;
